module.exports = __webpack_public_path__ + "img/Noctiluca-Process-5-mobile.849f8631.png";